import { render, staticRenderFns } from "./EditButtons.vue?vue&type=template&id=f7e0978e"
import script from "./EditButtons.vue?vue&type=script&lang=js"
export * from "./EditButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports